import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ImageCroppedEvent, OutputFormat} from "ngx-image-cropper";
import {closeCroppedImageWithWhiteBackground} from "../utils/image.utils";

@Component({
  selector: 'app-profile-image-cropper-dialog',
  templateUrl: './profile-image-cropper-dialog.component.html',
  styleUrl: './profile-image-cropper-dialog.component.scss'
})
export class ProfileImageCropperDialogComponent {

  imageChangedEvent: Event | null = null;
  croppedImage: Blob | null = null;
  cropperSize: number = 300;
  ratio: number = 1;
  imageQuality: number = 100;
  outputFormat: OutputFormat = 'png';

  constructor(
    private dialogRef: MatDialogRef<ProfileImageCropperDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.imageChangedEvent = data.imageChangedEvent;
  }

  imageCropped(event: ImageCroppedEvent) {
    if (event && event.blob) {
      this.croppedImage = event.blob;
    } else {
      console.error('No blob data found in cropped event:', event);
    }
  }

  async onCrop() {
    await closeCroppedImageWithWhiteBackground(this.dialogRef, this.croppedImage);
  }

  onCancel() {
    this.dialogRef.close(null);
  }

}
